// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18P4l","placeholdersHeader":"styles_placeholdersHeader__30qRJ","editorStyle":"styles_editorStyle__1KwEM","placeholdersBox":"styles_placeholdersBox__E9B9N"};